<template>
  <div class="main-div">
    <div class="session-meta-data-container">
      <div class="session-meta-data-form">
        <h4 v-if="adminOrDev == 1">Playtest Name</h4>
        <h4 v-if="adminOrDev == 2">Template Name</h4>
        <b-form-input placeholder="Name" class="metadata-input" v-model="template.name"></b-form-input>
      </div>
      <div class="session-meta-data-form">
        <h4 v-if="adminOrDev == 1">Timeline</h4>
        <label for="startDate">Start date:</label>
        <b-form-input type="date" id="startDate" class="metadata-input" v-model="template.startTime"></b-form-input>
        <label for="endDate">End date:</label>
        <b-form-input type="date" id="endDate" class="metadata-input" v-model="template.endTime"></b-form-input>
      </div>
    </div>

    <div class="session-meta-data-container">
      <div class="session-meta-data-form">
        <h4 v-if="adminOrDev == 1">Purpose</h4>
        <h4 v-if="adminOrDev == 2">Template Tags</h4>
        <hr>
        <div class="tag-space">
          <div class="clear-all-wrapper">
            <b-button class="clear-all-button" @click="clearAllTags">Clear All</b-button>
          </div>
          <div class="selected-tags">
            <b-button v-for="element in template.tags" :key="'template-tag-' + element" class="tag-button-chosen" @click="removeSelectedTag(element)">
              <div class="chosen-text">{{ element }}</div>
              <div class="x">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </div>
            </b-button>
          </div>
        </div>
        <hr>
        <div class="tag-parents">
          <b-button v-for="(item, i) in tagObject" :key="item.title + '-parent-' + i" class="tag-button-parent"
                    :style="{color: item.status ? '#FF7222 !important' : 'black'}"
                    @click="toggleParent(item), displayComponent(item.title)">{{ item.title }}
          </b-button>
        </div>
        <hr>
        <div class="tag-children">
          <b-button v-for="(item, i) in currArray" :key="item.tag + '-child-' + i" class="tag-button-child"
                    :style="{backgroundColor: item.selected ? '#DB3360 !important' : '#F4BECC'}"
                    @click="displaySelected(item)">{{ item.tag }}</b-button>
        </div>
      </div>

      <div class="session-meta-data-form">
        <h4 v-if="adminOrDev == 1">Link</h4>
        <b-form-input placeholder="Insert link" class="metadata-input" v-model="template.link"></b-form-input>
        
        <div v-if="adminOrDev == 1" class="opt-in-section">
          <h4>Opt in tasks</h4>
          <div class="checkbox-group">
            <input type="checkbox" id="webcam" v-model="template.useWebcam">
            <label for="webcam">I would like playtesters to use a webcam.</label><br>
            <input type="checkbox" id="social" v-model="template.shareSocial">
            <label for="social">I would like playtesters to share their experience on social media.</label><br>
            <input type="checkbox" id="transcription" v-model="template.transcription">
            <label for="transcription">I would like this playtest session to be transcribed.</label><br>
          </div>
        </div>
      </div>
    </div>

    <div class="session-meta-data-container">
      <div class="session-meta-data-form">
        <h4>Instructions</h4>
        <p class="grey-text">Add tasks you want testers to complete during the playtest.</p>

        <div class="instruction-input-row">
          <input
            v-model="taskInputData"
            class="instruction-input"
            placeholder="e.g. Navigate to the main menu and select a character"
            @keydown.enter="addInstruction()"
          />
          <button @click="addInstruction()" class="instruction-add-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" style="margin-right: 6px;">
              <path d="M8 1a.5.5 0 0 1 .5.5v6h6a.5.5 0 0 1 0 1h-6v6a.5.5 0 0 1-1 0v-6h-6a.5.5 0 0 1 0-1h6v-6A.5.5 0 0 1 8 1z"/>
            </svg>
            Add Task
          </button>
        </div>

        <div v-if="allInstructions.length === 0" class="instruction-empty-state">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#ccc" viewBox="0 0 16 16">
            <path d="M5 10.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0-2a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z"/>
            <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm0 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3z"/>
          </svg>
          <p>No tasks added yet</p>
        </div>

        <div v-else class="instruction-list">
          <div v-for="(instruction, index) in allInstructions" :key="index" class="instruction-item-wrapper">
            <div class="instruction-item" :class="{ 'instruction-item-required': instruction.required }">
              <button class="instruction-badge" @click="markInstructionRequired(instruction, index)">{{ index + 1 }}</button>
              <p  class="instruction-text">{{ instruction.instructionData }}</p>
              <button @click="removeTask(instruction)" class="instruction-remove-btn" title="Remove task">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
            </div>

            <div class="subtask-container">
              <div v-for="(subtask, sIndex) in (instruction.subtasks || [])" :key="sIndex" class="subtask-item">
                <span class="subtask-label">{{ subtaskLabel(index, sIndex) }}</span>
                <p class="subtask-text">{{ subtask }}</p>
                <button @click="removeSubtask(instruction, subtask)" class="subtask-remove-btn" title="Remove subtask">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                  </svg>
                </button>
              </div>

              <div class="subtask-input-row">
                <input
                  v-model="subtaskInputs[index]"
                  class="subtask-input"
                  placeholder="Add a subtask..."
                  @keydown.enter="handleAddSubtask(instruction, index)"
                />
                <button @click="handleAddSubtask(instruction, index)" class="subtask-add-btn">
                  + Subtask
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="session-meta-data-form">
        <div class="d-flex justify-content-between align-items-center">
            <h4 v-if="adminOrDev == 1" class="m-0">Add Testers <span class="required-asterisk">*</span></h4>
            <b-button v-b-modal.modal-add-testers class="add-step-button">Search Testers</b-button>
        </div>
        <p class="grey-text">Testers added will be assigned to this playtest.</p>
        
        <div class="selected-testers-list mt-3">
                <div v-for="testerId in template.testerIds" :key="testerId" class="selected-tester-pill">
                <span>{{ getTesterName(testerId) }}</span>
                <b-icon icon="x" @click="removeTester(testerId)" class="ml-2 pointer"></b-icon>
            </div>
            <div v-if="!template.testerIds || template.testerIds.length === 0" class="empty-tester-text empty-tester-required">
                At least one tester is required.
            </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-add-testers" title="Select Testers" size="lg" hide-footer centered>
        <div class="tester-filter-container">
            <b-form-input 
                v-model="searchTerm" 
                placeholder="Search by name" 
                class="mb-3 search-bar"
            ></b-form-input>
            
            <div v-if="isLoadingTesters" class="text-center p-4">
                <b-spinner label="Loading..." variant="primary"></b-spinner>
            </div>

            <div v-else class="tester-results-grid">
                <div v-if="displayedTesters.length === 0" class="text-center p-4 text-muted">
                    No testers are assigned to this project yet.
                </div>
                    <div v-for="tester in displayedTesters" :key="tester.id" class="tester-card">
                    <img class="tester-card-avatar" :src="tester.pic || require('../../assets/avatar_default.png')" alt="avatar">
                    <div class="tester-card-details">
                        <div class="tester-card-name">{{ tester.name || 'Anonymous' }}</div>
                        <div class="tester-card-achieve">Achievements: {{ tester.achievementsCompleted || 0 }}</div>
                    </div>
                    <b-button 
                        :class="isTesterSelected(tester.id) ? 'remove-btn' : 'add-btn'"
                        size="sm"
                        @click="toggleTesterSelection(tester.id)"
                    >
                        {{ isTesterSelected(tester.id) ? 'Remove' : 'Add' }}
                    </b-button>
                </div>
            </div>
        </div>
    </b-modal>
  </div>
</template>

<script>
import GamesObject from "../../Firestore/GamesObject";
import useInstructions from '../game-dashboard/dashboardComposables/useInstructions';
import { db } from "../../db";

export default {
  name: 'SessionMetaData',
  props: {
    adminOrDev: Number,
    template: Object
  },
  setup(){
     const {allInstructions, taskInputData, addInstruction, removeTask, addSubtask, removeSubtask} = useInstructions();

      return{
        allInstructions,
        taskInputData,
        addInstruction,
        removeTask,
        addSubtask,
        removeSubtask,

      }
      
  },
  data() {
    return {
      tagObject: [
        {title: 'Mechanics', status: true, tagsArr: ["Playability", "Combat", "Mechanics", "Indicators", "Environment", "Skill Tree", "Enemies", "Puzzles"]},
        {title: 'Usability', status: false, tagsArr: ["UI", "Controls", "Audio", "Dialogue", "Help", "Text", "Usability", "Menus" ]},
        {title: 'Systems', status: false, tagsArr: ["Map", "Customization", "Goals", "Navigation", "Tutorial", "Onboarding", "Objectives", "Level Design"]},
        {title: 'Design', status: false, tagsArr: ["Character", "Story", "NPC", "Art", "Music"]},
        {title: 'Performance', status: false, tagsArr: ["Balance", "Pacing", "Skill", "Immersion", "Difficulty", "Fun"]}
      ],
      currArray: [],
      instructionArray: [],
      transcription: null,

      searchTerm: "",
      allTesterList: [],
      isLoadingTesters: false,
      subtaskInputs: {},
    };
  },
    computed: {
    displayedTesters() {
      if (!this.searchTerm.trim()) return this.allTesterList;
      const term = this.searchTerm.toLowerCase();
      return this.allTesterList.filter(t =>
        (t.name || '').toLowerCase().includes(term)
      );
    },
    testersValid() {
      return !!(this.template.testerIds && this.template.testerIds.length > 0);
    }
  },
  mounted() {
    this.displayComponent("Mechanics");
    this.fetchProjectTesters();

    if (!this.template.testerIds) {
      this.$set(this.template, 'testerIds', []);
    }
  },
   watch: {
    allInstructions: {
      handler(newInstruction) {
        this.$emit('update-instructions', newInstruction);
      },
      deep: true
    },
    testersValid: {
      handler(isValid) {
        this.$emit('update-testers-valid', isValid);
      },
      immediate: true
    }
  },
  methods: {
    markInstructionRequired(instruction, index){
      if(instruction.required === false){
        instruction.required = true;
      }else
        instruction.required = false;
        //console.log(instruction.required);
    },
    subtaskLabel(index, sIndex){
      return `${index + 1}.${String.fromCharCode(97 + sIndex)}`;
    },
    handleAddSubtask(instruction, index){
      const text = (this.subtaskInputs[index] || '').trim();
      if (!text) return;
      this.addSubtask(instruction, text);
      this.$set(this.subtaskInputs, index, '');
    },
    fetchProjectTesters() {
      this.isLoadingTesters = true;
      const gameId = window.localStorage.getItem("gameId");

      GamesObject.getTestersFromProject(gameId)
        .then(res => {
          const testerIDs = res.data.testerIds || [];

          if (testerIDs.length === 0) {
            this.allTesterList = [];
            this.isLoadingTesters = false;
            return;
          }

          const profilePromises = testerIDs.map(id =>
            db.collection("User").doc(id).get()
                .then(doc => {
                if (!doc.exists) return null;
                return {
                  id: doc.id,
                  name: doc.data().userName || doc.data().nickName || null,
                  email: doc.data().email || null,
                  pic: doc.data().img || null,
                  achievementsCompleted: doc.data().achievementsCompleted || 0,
                };
              })
              .catch(() => null)
          );

            Promise.all(profilePromises)
            .then(results => {
              this.allTesterList = results.filter(t => t !== null);
              this.isLoadingTesters = false;

              if (!this.template.testerIds || this.template.testerIds.length === 0) {
                this.$set(this.template, 'testerIds', this.allTesterList.map(t => t.id));
              }
            })
            .catch(() => {
              this.isLoadingTesters = false;
            });
        })
        .catch(error => {
          console.error("Failed to fetch project testers:", error);
          this.isLoadingTesters = false;
        });
    },

    toggleTesterSelection(testerId) {
      const index = this.template.testerIds.indexOf(testerId);
      if (index > -1) {
        this.template.testerIds.splice(index, 1);
      } else {
        this.template.testerIds.push(testerId);
      }
    },
    isTesterSelected(testerId) {
      return this.template.testerIds.includes(testerId);
    },
    removeTester(testerId) {
      this.toggleTesterSelection(testerId);
    },
    getTesterName(testerId) {
      const tester = this.allTesterList.find(t => t.id === testerId);
      return tester ? (tester.name || 'Anonymous') : testerId;
    },

    displayComponent(categoryInput) {
      this.tagObject.forEach(o => {
        if (o.title === categoryInput) {
          this.currArray = [];
          for (let i = 0; i < o.tagsArr.length; i++) {
            this.currArray.push({
              tag: o.tagsArr[i],
              selected: this.template.tags.includes(o.tagsArr[i])
            });
          }
        }
      });
    },
    displaySelected(elementID) {
      const index = this.currArray.indexOf(elementID);
      this.currArray[index].selected = true;
      if (!this.template.tags.includes(elementID.tag)) {
        this.template.tags.push(elementID.tag);
      }
    },
    clearAllTags() {
      this.template.tags = [];
      this.currArray.forEach(o => o.selected = false);
    },
    removeSelectedTag(elementToRemove) {
      const index = this.template.tags.indexOf(elementToRemove);
      this.template.tags.splice(index, 1);
      this.currArray.forEach(o => {
        if (o.tag === elementToRemove) o.selected = false;
      });
    },
    toggleParent(element) {
      this.tagObject.forEach(o => o.status = false);
      element.status = true;
    }
  }
}
</script>

<style scoped>
.main-div {
  background-color: #eee;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.session-meta-data-form {
  display: inline-block;
  width: 80%;
  background-color: #fff;
  padding: 1.5rem 3rem;
  margin: 1rem 0.5rem 0 0.5rem;
  border-radius: 30px;
  text-align: left;
}
.session-meta-data-form:nth-of-type(3), 
.session-meta-data-container:last-of-type .session-meta-data-form {
  margin-bottom: 2%;
  min-height: 350px;
}
.metadata-input {
  width: 95% !important;
  margin: 0.5rem !important;
  background-color: #eee !important;
  border: 0 !important;
}
h4 {
  color: #FF7222;
  margin-left: 1% !important;
  font-weight: bold !important;
  margin-top: 1% !important;
  margin-bottom: 0.8% !important;
}
p.grey-text {
  color: #bbb !important;
  margin-left: 1%;
  margin-top: -0.2%;
}
hr {
  width: 95%;
  margin-left: 1%;
  border: 1px solid #ccc !important;
  background-color: #eee !important;
}
.tag-space { display: flex; }
.selected-tags { width: 85%; display: flex; flex-wrap: wrap; }
.tag-button-chosen {
  display: flex;
  align-items: center;
  margin: 0.3% 0.5%;
  background-color: #DB3360 !important;
  border-radius: 10px;
  border: none;
  color: white;
  padding: 5px 10px;
}
.tag-parents { display: flex; justify-content: space-evenly; width: 100%; margin: -1% auto; }
.tag-children { width: 100%; display: flex; flex-wrap: wrap; }
.tag-button-parent { color: black; background-color: #fff; font-weight: bold; border: none; }
.tag-button-child, .transcript-button {
  background-color: #F4BECC !important;
  margin: 0.3% 0.5% !important;
  border-radius: 10px;
  border: none;
}
.transcript-button-chosen { background-color: #DB3360 !important; color: white; border-radius: 10px; border: none; }

.instruction-input-row {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 1.2rem;
  margin-top: 0.5rem;
}
.instruction-input {
  flex: 1;
  background-color: #f5f5f5;
  border: 1.5px solid #e0e0e0;
  border-radius: 12px;
  padding: 10px 16px;
  font-size: 0.9rem;
  color: #333;
  outline: none;
  transition: border-color 0.2s;
}
.instruction-input:focus {
  border-color: #FF7222;
  background-color: #fff;
}
.instruction-input::placeholder {
  color: #bbb;
}
.instruction-add-btn {
  display: flex;
  align-items: center;
  background-color: #FF7222;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s, transform 0.1s;
}
.instruction-add-btn:hover { background-color: #e5651a; }

.instruction-add-btn:active { transform: scale(0.97); }

.instruction-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #ccc;
  background-color: #fafafa;
  border-radius: 14px;
  border: 1.5px dashed #e0e0e0;
  gap: 8px;
}
.instruction-empty-state p {
  margin: 0;
  font-size: 0.9rem;
  color: #ccc;
}

.instruction-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.instruction-item {
  display: flex;
  align-items: center;
  gap: 14px;
  background-color: #fafafa;
  border: 1.5px solid #f0f0f0;
  border-radius: 14px;
  padding: 12px 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.instruction-item:hover {
  border-color: #FF7222;
  box-shadow: 0 2px 8px rgba(255, 114, 34, 0.08);
}
/*This is layered on top of instruction-item */
.instruction-item-required{
  border-color: #DB3360;
}

.instruction-badge {
  min-width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #FF7222;
  color: white;
  font-size: 0.78rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid #e5651a;
}
.instruction-badge:hover{
  border: 2px solid #DB3360;
}
.instruction-badge:active{
  border-color: #e5651a;
  border: tomato;
}

.instruction-text {
  flex: 1;
  margin: 0;
  font-size: 0.9rem;
  color: #333;
  line-height: 1.4;
}
.instruction-text-required{

}
.instruction-remove-btn {
  background: none;
  border: none;
  color: #bbb;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
}
.instruction-remove-btn:hover {
  color: #DB3360;
  background-color: #fdeef3;
}

.subtask-container {
  margin-left: 42px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.subtask-item {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #fff;
  border: 1px solid #f0f0f0;
  border-left: 3px solid #FF7222;
  border-radius: 10px;
  padding: 8px 12px;
}

.subtask-label {
  font-size: 0.75rem;
  font-weight: 700;
  color: #FF7222;
  flex-shrink: 0;
  min-width: 28px;
}

.subtask-text {
  flex: 1;
  margin: 0;
  font-size: 0.85rem;
  color: #555;
}

.subtask-remove-btn {
  background: none;
  border: none;
  color: #bbb;
  cursor: pointer;
  padding: 3px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s, background-color 0.2s;
  flex-shrink: 0;
}
.subtask-remove-btn:hover {
  color: #DB3360;
  background-color: #fdeef3;
}

.subtask-input-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.subtask-input {
  flex: 1;
  background-color: #f5f5f5;
  border: 1.5px solid #e0e0e0;
  border-radius: 10px;
  padding: 6px 12px;
  font-size: 0.82rem;
  color: #333;
  outline: none;
  transition: border-color 0.2s;
}
.subtask-input:focus {
  border-color: #FF7222;
  background-color: #fff;
}
.subtask-input::placeholder {
  color: #bbb;
}

.subtask-add-btn {
  background-color: transparent;
  color: #FF7222;
  border: 1.5px dashed #FF7222;
  border-radius: 10px;
  padding: 6px 14px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.2s;
}
.subtask-add-btn:hover {
  background-color: #fff1ea;
}

.selected-testers-list { display: flex; flex-wrap: wrap; gap: 8px; }

.selected-tester-pill {
  background-color: #f0f0f0;
  padding: 5px 15px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  border: 1px solid #ddd;
}
.pointer { cursor: pointer; }

.tester-card {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #fbfbfb;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.tester-card:hover {
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}
.tester-card-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #eee;
}
.tester-card-details {
  flex: 1;
  min-width: 0;
}
.tester-card-name {
  font-weight: 700;
  font-size: 14px;
  color: #FC7727;
  margin-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tester-card-achieve {
  font-size: 11px;
  font-weight: 600;
  color: #888;
}

.required-asterisk {
  color: #DB3360;
  margin-left: 2px;
}
.empty-tester-required {
  color: #DB3360;
  font-weight: 600;
}

>>> .modal-header .close {
  padding: 0px;
  margin-left: auto;
  margin-right: 2px;
  border: none;
  background: none;
  font-size: 24px;
  color: #FF7222 !important;
  opacity: 1 !important;
}
>>> .modal-header .close:hover {
  color: #DB3360 !important;
}

.add-btn { background-color: #FF7222 !important; border: none; }
.remove-btn { background-color: #6c757d !important; border: none; }
.search-bar { border-radius: 20px; padding-left: 20px; background-color: #f8f8f8; }

.session-meta-data-container { display: flex; width: 100%; align-items: stretch; }
.opt-in-section { margin-top: 1.5rem; }
.checkbox-group { margin-left: 1%; }
.checkbox-group label { margin-left: 0.5rem; font-size: 0.9rem; color: #333; }
.add-step-button { background-color: #FF7222; border: none; color: white; border-radius: 10px; padding: 5px 15px; }
.clear-all-button { background-color: #FF7222; border: none; color: white; border-radius: 10px; padding: 5px 15px; }
.field-label { font-size: 12px; color: #666; text-transform: uppercase; font-weight: 600; margin-bottom: 8px; letter-spacing: 0.5px; display: flex; }
.field-label > div { margin-left: auto; }
</style>


// WEBPACK FOOTER //
// src/components/session-create/SessionMetaData.vue